import { observable } from "mobx";
import { Location } from "./Location";
import { PaymentInformation } from "./PaymentInformation";

export class Customer {
    @observable accountsReceivables: number;
    @observable externalReferenceCode: string;
    @observable companyAddress: string;
    @observable fullName: string;
    @observable id: string;
    @observable isInactive: boolean;
    @observable isReadOnly: boolean;
    @observable overdueAccountsReceivables: number;
    @observable phoneNumber: string;
    @observable taxId: string;
    @observable orgSalesRepId: string;
    @observable orgId: string;
    @observable locations: Array<Location>;
    @observable paymentInformation: PaymentInformation;

    constructor() {
        this.accountsReceivables = 0;
        this.externalReferenceCode = "";
        this.companyAddress = "";
        this.fullName = "";
        this.id = "";
        this.isInactive = false;
        this.isReadOnly = false;
        this.overdueAccountsReceivables = 0;
        this.phoneNumber = "";
        this.taxId = "";
        this.orgSalesRepId = "";
        this.orgId = "";
        this.locations = [];
        this.paymentInformation = new PaymentInformation();
    }
}